import React, { useMemo } from 'react';

import { useAppSelector } from 'store/hooks';

import { RequiredFields } from 'components/RequiredFields';
import { hasRequiredFields } from 'src/utils/requiredUtils';
import Loader from 'src/components/Loader/Loader';
import { SUBSCRIPTION_ACTIVE_STATUSES } from 'src/api/types/user';
import SubscriptionHandler from 'src/Pages/SubscriptionHandler';

export const ParentGuard = ({ children }: { children: React.ReactNode }) => {
  const user = useAppSelector((state) => state.auth.user);
  const featureFlags = useAppSelector((state) => state.auth.featureFlags);

  const areUserFieldsValid = useMemo(() => hasRequiredFields(user), [user]);

  if (!user) {
    return <Loader />;
  }

  if (!areUserFieldsValid) {
    return <RequiredFields />;
  }

  if (
    !user?.stripeSubscriptionStatus ||
    !SUBSCRIPTION_ACTIVE_STATUSES.includes(user?.stripeSubscriptionStatus) ||
    !featureFlags?.uiAccess
  ) {
    return <SubscriptionHandler />;
  }

  return <>{children}</>;
};
